export class BackupJobsFilterConditions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "jobId",
            "baseName": "jobId",
            "type": "JobIdFilters",
            "format": ""
        },
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "SnapshotIdFilters",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "JobStatusFilters",
            "format": ""
        },
        {
            "name": "providerResourceId",
            "baseName": "providerResourceId",
            "type": "ResourceIdFilters",
            "format": ""
        },
        {
            "name": "backupType",
            "baseName": "backupType",
            "type": "BackupJobTypeFilters",
            "format": ""
        },
        {
            "name": "startTime",
            "baseName": "startTime",
            "type": "StartTimeDateFilters",
            "format": ""
        },
        {
            "name": "endTime",
            "baseName": "endTime",
            "type": "EndTimeDateFilters",
            "format": ""
        },
        {
            "name": "vaultId",
            "baseName": "vaultId",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "ResourceTypeFilters",
            "format": ""
        },
        {
            "name": "providerAccountId",
            "baseName": "providerAccountId",
            "type": "ProviderAccountIdFilters",
            "format": ""
        },
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "ResourceNameFilters",
            "format": ""
        },
        {
            "name": "internalResourceId",
            "baseName": "internalResourceId",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "initiatorName",
            "baseName": "initiatorName",
            "type": "InitiatorNameFilters",
            "format": ""
        },
        {
            "name": "isOnDemand",
            "baseName": "isOnDemand",
            "type": "BooleanFilters",
            "format": ""
        },
        {
            "name": "classificationPolicyId",
            "baseName": "classificationPolicyId",
            "type": "IdFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupJobsFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
